import React from "react"

const BlurPage:React.FC = () => {
    return (
        <div style={{position:'fixed',bottom:'0',right:'0',left:'0',top:'0',zIndex:'290'}}>
        </div>
    )
}

export default BlurPage